// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";

// Soft UI Dashboard PRO React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
// Invoice page components
import BaseLayout from "layouts/pages/components/BaseLayout";
// Images
import logoCT from "assets/images/cxfabric_gradient 1.png";
//Invoice Stripe req
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { invoices } from "../billing/api/invoicesApi";
const { borderWidth } = borders;

function Invoice() {
	const { light } = colors;
	const borderBottom = `${borderWidth[1]} solid ${light.main}`;
	const invoiceId = useParams().inv_Id;
	const [invsRcpt, setinvRcpt] = useState([]);

	const handleChange = (value) => {
		if (value.value === "print")
			window.print();
	};

	useEffect(() => {
		fetchInvReceipt();
	}, []);

	async function fetchInvReceipt() {
		try {
			const response = await invoices();
			setinvRcpt(response?.resultObject?.data || []);
		} catch (error) {
			console.log(error);
		}
	}

	const formatPrice = (price) => (parseInt(price) / 100).toFixed(2);

	function formatDateFromUnixTime(unixTime) {
		const date = new Date(unixTime * 1000);
		const months = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		];
		const monthIndex = date.getMonth();
		const monthName = months[monthIndex];
		const day = date.getDate();
		const year = date.getFullYear();
		const formattedDate = `${monthName} ${day}, ${year}`;
		return formattedDate;
	}

	function formatDate(dateString) {
		const formattedDate = dateString?.substring(0, dateString?.length - 6);
		return formattedDate;
	}

	return (
		<BaseLayout>
			<SoftBox
				mt={{ xs: 2, md: 4 }}
				mb={{ xs: 4, md: 8 }}
			>
				<Grid
					container
					justifyContent="center"
				>
					<Grid
						size={{ xs: 12, sm: 12, md: 8 }}
						mb={{ xs: 2, md: 2 }}
					>
						<SoftButton>Pay this Invoice</SoftButton>
					</Grid>
					<Grid size={{ xs: 12, sm: 10, md: 8 }}>
						<>
							{invsRcpt
								?.filter((data) => data.id === invoiceId)
								?.map((data, index) => {
									return (
										<>
											<Card key={index}>
												{/* Invoice header */}
												<SoftBox p={3}>
													<Grid
														container
														justifyContent="space-between"
													>
														<Grid size={{ xs: 6, md: 6 }}>
															<SoftBox
																display="flex"
																justifyContent="flex-start"
															>
																<SoftTypography
																	variant="h6"
																	fontWeight="medium"
																	mt={1}
																>
																	Invoice
																</SoftTypography>
															</SoftBox>
														</Grid>

														<Grid size={{ xs: 6, md: 6 }}>
															<SoftBox
																display="flex"
																justifyContent="flex-end"
															>
																<SoftBox
																	component="img"
																	src={logoCT}
																	width={{
																		xs: "85%",
																		md: "50%",
																		lg: "30%"
																	}}
																	p={{ xs: 2, md: 1 }}
																	mb={{ md: 1 }}
																/>
															</SoftBox>
														</Grid>
													</Grid>

													<Grid
														container
														direction={{
															xs: "column",
															md: "row"
														}}
													>
														<Grid
															size={{ xs: 12, md: 12 }}
															display={{ md: "flex" }}
															alignItems="center"
														>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																mr={1}
															>
																Invoice number
															</SoftTypography>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
															>
																{data.number}
															</SoftTypography>
														</Grid>

														<Grid
															size={{ xs: 12, md: 12 }}
															display={{ md: "flex" }}
															alignItems="center"
														>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																mr={1}
															>
																Date of issue
															</SoftTypography>

															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
															>
																{formatDateFromUnixTime(
																	data.created
																)}
															</SoftTypography>
														</Grid>

														<Grid
															size={{ xs: 12, md: 12 }}
															display={{ md: "flex" }}
															alignItems="center"
														>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																mr={1}
															>
																Date of issue
															</SoftTypography>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
															>
																{formatDateFromUnixTime(
																	data.period_end
																)}
															</SoftTypography>
														</Grid>
													</Grid>

													<SoftBox mt={{ xs: 5, md: 5 }}>
														<Grid container>
															<Grid
																size={{ xs: 12, md: 6 }}
																display="flex"
																direction="column"
															>
																<SoftTypography
																	variant="h6"
																	fontWeight="medium"
																>
																	CXFabric, LLC
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	9111 Jollyville Road
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	Ste 155
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	Austin, Texas 78759
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	United States
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	+1 737-270-8834
																</SoftTypography>
															</Grid>

															<Grid
																item
																xs={12}
																md={3}
																display="flex"
																direction="column"
																mt={{ xs: 2 }}
															>
																<SoftTypography
																	variant="h6"
																	fontWeight="medium"
																>
																	Bill to
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_name}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_address.line1}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_address.city}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_address
																		.postal_code +
																		" " +
																		data.customer_address
																			.state}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{
																		data.customer_address
																			.country
																	}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_phone}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_email}
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_tax_ids[0]
																		.type +
																		" " +
																		data.customer_tax_ids[0]
																			.value}
																</SoftTypography>
															</Grid>
															<Grid
																item
																xs={12}
																md={3}
																display="flex"
																direction="column"
																mt={{ xs: 2 }}
															>
																<SoftTypography
																	variant="h6"
																	fontWeight="medium"
																>
																	Ship to
																</SoftTypography>
																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_shipping.name}
																</SoftTypography>

																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{
																		data.customer_shipping
																			.address.line1
																	}
																</SoftTypography>

																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{
																		data.customer_shipping
																			.address.city
																	}
																</SoftTypography>

																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{data.customer_shipping
																		.address.postal_code +
																		" " +
																		data.customer_shipping
																			.address.state}
																</SoftTypography>

																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{
																		data.customer_shipping
																			.address.country
																	}
																</SoftTypography>

																<SoftTypography
																	variant="caption"
																	fontWeight="regular"
																	color="text"
																>
																	{
																		data.customer_shipping
																			.phone
																	}
																</SoftTypography>
															</Grid>
														</Grid>
													</SoftBox>

													<SoftBox mt={{ xs: 5, md: 5 }}>
														<Grid container>
															<Grid size={{ xs: 12, md: 4 }}>
																<SoftTypography
																	variant="h6"
																	fontWeight="medium"
																>
																	{"$" +
																		" " +
																		formatPrice(
																			data.amount_due
																		) +
																		" " +
																		formatDateFromUnixTime(
																			data.due_date
																		)}
																</SoftTypography>
																<SoftTypography
																	variant="h6"
																	color="secondary"
																	fontWeight="medium"
																	sx={{
																		textDecoration:
																			"underline"
																	}}
																>
																	<a
																		href={
																			data.hosted_invoice_url
																		}
																	>
																		Pay online
																	</a>
																</SoftTypography>
															</Grid>
														</Grid>
													</SoftBox>
												</SoftBox>

												{/* Invoice table */}
												<SoftBox p={3}>
													<SoftBox
														width="100%"
														overflow="auto"
													>
														<Table sx={{ minWidth: "32rem" }}>
															<SoftBox component="thead">
																<TableRow>
																	<SoftBox
																		component="th"
																		width={{
																			xs: "45%",
																			md: "50%"
																		}}
																		py={1.5}
																		px={1}
																		textAlign="left"
																		borderBottom={
																			borderBottom
																		}
																	>
																		<SoftTypography
																			variant="h6"
																			color="text"
																			fontWeight="medium"
																		>
																			Description
																		</SoftTypography>
																	</SoftBox>
																	<SoftBox
																		component="th"
																		py={1.5}
																		pl={3}
																		pr={1}
																		textAlign="left"
																		borderBottom={
																			borderBottom
																		}
																	>
																		<SoftTypography
																			variant="h6"
																			color="text"
																			fontWeight="medium"
																		>
																			Qty
																		</SoftTypography>
																	</SoftBox>
																	<SoftBox
																		component="th"
																		py={1.5}
																		pl={3}
																		pr={1}
																		textAlign="left"
																		borderBottom={
																			borderBottom
																		}
																	>
																		<SoftTypography
																			variant="h6"
																			color="text"
																			fontWeight="medium"
																		>
																			Unit Price
																		</SoftTypography>
																	</SoftBox>

																	<SoftBox
																		component="th"
																		py={1.5}
																		pl={3}
																		pr={1}
																		textAlign="right"
																		borderBottom={
																			borderBottom
																		}
																	>
																		<SoftTypography
																			variant="h6"
																			color="text"
																			fontWeight="medium"
																		>
																			Amount
																		</SoftTypography>
																	</SoftBox>
																</TableRow>
															</SoftBox>

															<TableBody>
																{data.lines.data.map(
																	(subData) => {
																		3;
																		const unitAmount = Number(
																			formatPrice(
																				subData.unit_amount_excluding_tax
																			)
																		);
																		const quantity = Number(
																			subData.quantity
																		);
																		const totalAmount =
																			unitAmount * quantity;

																		return (
																			<TableRow
																				key={subData.id}
																			>
																				<SoftBox
																					component="td"
																					textAlign="left"
																					p={1}
																					borderBottom={
																						borderBottom
																					}
																				>
																					<SoftTypography
																						variant="body2"
																						color="text"
																					>
																						{
																							subData.description
																						}
																					</SoftTypography>
																					<SoftTypography
																						variant="body2"
																						color="text"
																					>
																						{formatDate(
																							formatDateFromUnixTime(
																								subData
																									.period
																									.start
																							)
																						) +
																							"-" +
																							formatDateFromUnixTime(
																								subData
																									.period
																									.end
																							)}
																					</SoftTypography>
																				</SoftBox>
																				<SoftBox
																					component="td"
																					textAlign="left"
																					py={1}
																					pr={1}
																					pl={3}
																					borderBottom={
																						borderBottom
																					}
																				>
																					<SoftTypography
																						variant="body2"
																						color="text"
																					>
																						{
																							subData.quantity
																						}
																					</SoftTypography>
																				</SoftBox>
																				<SoftBox
																					component="td"
																					textAlign="left"
																					py={1}
																					pr={1}
																					pl={3}
																					borderBottom={
																						borderBottom
																					}
																				>
																					<SoftTypography
																						variant="body2"
																						color="text"
																					>
																						{(subData.currency ===
																						"usd"
																							? "$"
																							: "") +
																							" " +
																							formatPrice(
																								subData
																									.price
																									.unit_amount_decimal
																							)}
																					</SoftTypography>
																				</SoftBox>

																				<SoftBox
																					component="td"
																					textAlign="right"
																					py={1}
																					pr={1}
																					pl={3}
																					borderBottom={
																						borderBottom
																					}
																				>
																					<SoftTypography
																						variant="body2"
																						color="text"
																					>
																						{(subData.currency ===
																						"usd"
																							? "$"
																							: "DZD") +
																							" " +
																							totalAmount}
																					</SoftTypography>
																				</SoftBox>
																			</TableRow>
																		);
																	}
																)}
															</TableBody>
														</Table>
													</SoftBox>

													<Grid
														container
														display="flex"
													>
														<Grid
															item
															xs={12}
															md={12}
															lg={12}
															display={{
																xs: "flex",
																md: "flex"
															}}
															justifyContent={{
																xs: "flex-end",
																md: "flex-end"
															}}
														>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																mr={2}
																pr={{ md: 35 }}
																borderBottom={borderBottom}
															>
																Subtotal
															</SoftTypography>

															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																pr={1}
																borderBottom={borderBottom}
															>
																{"$" +
																	" " +
																	formatPrice(
																		data.subtotal_excluding_tax
																	)}
															</SoftTypography>
														</Grid>

														<Grid
															item
															xs={12}
															md={12}
															lg={12}
															display={{
																xs: "flex",
																md: "flex"
															}}
															justifyContent={{
																xs: "flex-end",
																md: "flex-end"
															}}
														>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																mr={2}
																pr={{ md: 38 }}
																borderBottom={borderBottom}
															>
																Total
															</SoftTypography>

															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																pr={1}
																borderBottom={borderBottom}
															>
																{"$" +
																	" " +
																	formatPrice(data.total)}
															</SoftTypography>
														</Grid>
														<Grid
															item
															xs={12}
															md={12}
															lg={12}
															display={{
																xs: "flex",
																md: "flex"
															}}
															justifyContent={{
																xs: "flex-end",
																md: "flex-end"
															}}
														>
															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																mr={{ md: "2" }}
																pr={{ md: 33 }}
																borderBottom={borderBottom}
															>
																Amount due
															</SoftTypography>

															<SoftTypography
																variant="h6"
																fontWeight="medium"
																mt={1}
																pr={1}
																borderBottom={borderBottom}
															>
																{"$" +
																	" " +
																	formatPrice(data.amount_due)}
															</SoftTypography>
														</Grid>
													</Grid>
												</SoftBox>

												{/* Invoice footer */}
												<SoftBox
													p={3}
													mt={7}
													display="flex"
													justifyContent="flex-end"
												>
													<Grid
														container
														style={{
															height: "200px",
															width: "200px"
														}}
														direction="column"
													>
														<Grid size={{ xs: 12, lg: 12 }}>
															<SoftSelect
																placeholder="Select Option"
																options={[
																	{
																		value: "print",
																		label: "Print"
																	},
																	{
																		value: "saveAsPdf",
																		label: "Save as PDF"
																	},
																	{
																		value: "sendAsEmail",
																		label: "Send as email"
																	}
																]}
																onChange={(value) => {
																	if (
																		value.value ===
																		"saveAsPdf"
																	) {
																		{
																			window.open(
																				data.invoice_pdf,
																				"_blank"
																			);
																		}
																	} else {
																		handleChange(value);
																	}
																}}
															/>
														</Grid>
													</Grid>
												</SoftBox>
											</Card>
										</>
									);
								})}
						</>
					</Grid>
				</Grid>
			</SoftBox>
		</BaseLayout>
	);
}

export default Invoice;
